// extracted by mini-css-extract-plugin
module.exports = {"dashboard-component":"dashboardComponent_dashboard-component__10t55"};